import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-accent/15 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-155" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-156" data-mp="2vppn17ywe6cr">
        <div className="text-center" data-id="element-157" data-mp="39hvywhv0pr6e">
          <SectionHeading id="problem-title" data-id="element-158" data-mp="39guq6k1h5gru">Ti suona <span className="text-accent" data-id="element-159" data-mp="39jqmy51l5zep">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-160" data-mp="35fr6fmgb30lc">
            Il vino ti appassiona, ma tra etichette, vitigni, denominazioni e degustazione le informazioni sono tante e
            sparse. Leggi un articolo qui, guardi un video là, e alla fine i pezzi non si collegano mai.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-accent/20 bg-background/55 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-161" data-mp="1k2xy2xh16a4s">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-foreground" data-id="element-162" data-mp="sc8mvwjbk94n">
            <AlertTriangleIcon className="h-5 w-5 text-primary" aria-hidden="true" data-id="element-163" data-mp="x5td32eo7yta" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-164" data-mp="172pk13ox8cvq">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-165" data-mp="174skyirm3qf8">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-accent" aria-hidden="true" data-id="element-166" data-mp="1c2kbp9git6hu" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-167" data-mp="3dugwzashpupt">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-168" data-mp="3hur3cok72n57">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-primary sm:text-3xl" data-id="element-169" data-mp="p1bpfs8psyra">Ti serve un percorso completo e ordinato.</p>
        </div>
      </div>
    </section>;
}